export const CREATE_TASK = '@NEW_TASK_FORM/CREATE_TASK';
export const CREATE_PROJECT = '@NEW_TASK_FORM/CREATE_PROJECT';
export const SAVE_TASK = '@NEW_TASK_FORM/SAVE_TASK';
export const PUT = '@NEW_TASK_FORM/PUT';


export const actionCreators = {
    createTask: (task) =>{ return   ({ type: CREATE_TASK, payload: task })},
    createProject: (project) =>{  return   ({ type: CREATE_PROJECT, payload: project })},
    saveTask: (task) =>  ({ type: SAVE_TASK, payload: task }),
    putTask: (task) => ({ type: PUT, payload: task }),
}
